document.addEventListener("DOMContentLoaded", function () {
    const wishlistContainer = document.getElementById("wishlist-items");
    const clearWishlistButton = document.getElementById("clear-wishlist");
    const addAllToCartButton = document.getElementById("add-all-to-cart");

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    // Ensure buttons are not duplicated
    if (document.querySelectorAll("#clear-wishlist").length > 1) {
        document.querySelectorAll("#clear-wishlist")[1].remove();
    }
    if (document.querySelectorAll("#add-all-to-cart").length > 1) {
        document.querySelectorAll("#add-all-to-cart")[1].remove();
    }

    if (wishlist.length === 0) {
        wishlistContainer.innerHTML = "<p>Tu lista de favoritos está vacía.</p>";
        if (clearWishlistButton) clearWishlistButton.style.display = "none";
        if (addAllToCartButton) addAllToCartButton.style.display = "none";
        return;
    }

    wishlistContainer.innerHTML = ""; // Clear previous content
    let renderedProducts = new Set(); // Track rendered products

    wishlist.forEach(productHandle => {
        if (renderedProducts.has(productHandle)) return; // Prevent duplicate rendering
        renderedProducts.add(productHandle);

        fetch(`/products/${productHandle}.json`)
            .then(response => response.json())
            .then(data => {
                let product = data.product;
                let existingItem = document.querySelector(`[data-handle="${product.handle}"]`);

                // Prevent adding if it already exists
                if (!existingItem) {
                    let productHTML = `
                        <div class="wishlist-item" data-handle="${product.handle}">
                            <a href="/products/${product.handle}">
                                <img src="${product.images[0].src}" alt="${product.title}" width="100">
                                <p>${product.title}</p>
                                <p>${product.variants[0].price}</p>
                            </a>
                            <button class="remove-wishlist" data-id="${productHandle}">❌ Quitar de Favoritos</button>
                        </div>
                    `;
                    wishlistContainer.insertAdjacentHTML('beforeend', productHTML);
                }
            })
            .catch(error => console.error("Error fetching product:", error));
    });

    // Remove single item from wishlist
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("remove-wishlist")) {
            let productHandle = event.target.getAttribute("data-id");
            wishlist = wishlist.filter(handle => handle !== productHandle);
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            event.target.closest(".wishlist-item").remove();

            if (wishlist.length === 0) {
                wishlistContainer.innerHTML = "<p>Tu lista de favoritos está vacía.</p>";
                if (clearWishlistButton) clearWishlistButton.style.display = "none";
                if (addAllToCartButton) addAllToCartButton.style.display = "none";
            }
        }
    });

    // Clear entire wishlist
    if (clearWishlistButton) {
        clearWishlistButton.style.display = "block"; // Ensure visibility
        clearWishlistButton.onclick = function () {
            localStorage.removeItem("wishlist");
            wishlist = [];
            wishlistContainer.innerHTML = "<p>Tu lista de favoritos está vacía.</p>";
            clearWishlistButton.style.display = "none";
            if (addAllToCartButton) addAllToCartButton.style.display = "none";
        };
    }

    // Add all wishlist items to cart
    if (addAllToCartButton) {
        addAllToCartButton.style.display = "block"; // Ensure visibility
        addAllToCartButton.onclick = function () {
            if (wishlist.length === 0) return;

            let cartData = wishlist.map(handle =>
                fetch(`/products/${handle}.json`)
                    .then(response => response.json())
                    .then(data => ({
                        id: data.product.variants[0].id,
                        quantity: 1
                    }))
            );

            Promise.all(cartData).then(items => {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: items })
                })
                .then(response => response.json())
                .then(() => { window.location.href = "/cart"; })
                .catch(error => console.error("Error adding to cart:", error));
            });
        };
    }
});

// Fix "Add to Favorites" button functionality
document.addEventListener("DOMContentLoaded", function () {
    const wishlistButtons = document.querySelectorAll(".wishlist-button");
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    function updateButtonState(button, productHandle) {
        if (wishlist.includes(productHandle)) {
            button.innerHTML = "✅ Guardado a tus Favoritos";
        } else {
            button.innerHTML = "❤️ Guardar en tus Favoritos";
        }
    }

    wishlistButtons.forEach((button) => {
        const productHandle = button.getAttribute("data-product-handle");
        updateButtonState(button, productHandle);

        button.addEventListener("click", function () {
            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter((handle) => handle !== productHandle);
            } else {
                wishlist.push(productHandle);
            }
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            updateButtonState(button, productHandle);
            console.log("Wishlist updated:", wishlist);
        });
    });
});
